'use client';
import { ButtonProps } from '@mui/material';
import { OutlinedButtonWrapper, OutlinedButtonLabel } from './styles';

interface OutlinedButtonProps extends ButtonProps {
    readonly label: string;
    readonly icon?: React.ReactNode;
    readonly labelColor?: string;
}

const OutlinedButton = (props: OutlinedButtonProps) => {
    const { icon, label, labelColor, ...buttonProps } = props;
    return (
        <OutlinedButtonWrapper variant={'outlined'} {...buttonProps}>
            {icon && icon}
            <OutlinedButtonLabel
                hasIcon={!!icon}
                isDisabled={props.disabled}
                labelColor={labelColor}
                noWrap
            >
                {label}
            </OutlinedButtonLabel>
        </OutlinedButtonWrapper>
    );
};

export { OutlinedButton };
